// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-wrapper[data-v-7e6a7268]{background-color:#fff;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.14),0 0 2px 0 rgba(0,0,0,.12);box-shadow:0 2px 4px 0 rgba(0,0,0,.14),0 0 2px 0 rgba(0,0,0,.12)}.header-wrapper .container[data-v-7e6a7268]{max-width:1200px}", ""]);
// Exports
module.exports = exports;
